export default __webpack_public_path__ + "static/media/model_diagram_2.e38249f4.png";